$(document).ready( function () {
    function makeCardAd(ad) {
        return `
        <a class="col" href="${ad.links.href}" target="_blank">
            <img src="${ad.links.img}">
        </a>`;
    }

    function getCardAds(num) {
        return $.get('/horizontal/ads', {
            num,
        });
    }

    function chunkify(arr, perChunk) {
        return arr.reduce((chunked, el, i) => {
            const chunk = Math.floor(i / perChunk);

            if (chunk === chunked.length) {
                chunked.push([]);
            }

            chunked[chunk].push(el);

            return chunked;
        }, []);
    }

    const $containers = $('.ajax-card-ad-container');
    const numContainers = $containers.length;
    const adsPerContainer = $('.legacy-ad-row').length || $('.job-results-ad-row').length ? 3 : 2;
    const numAds = numContainers * adsPerContainer;

    if (numContainers > 0) {
        getCardAds(numAds)
            .then(function (ads) {
                chunkify(ads, adsPerContainer)
                    .forEach((adsInContainer, containerIndex) => {
                        const $container = $containers.eq(containerIndex);
                        const adHtml = adsInContainer
                            .map(makeCardAd)
                            .join('');

                        $container.html(adHtml);
                    });
            });
    }
});
